import { champsSignataireEnum, champsSuiveurEnum } from '../enums/champsSignataireEnum'
import { methodeAuthentification, positionSignature, typeSignataire } from '../../types/popinAjoutInterneExterneModel'

export const INITIAL_VALEURS_FORMULAIRE = {
	[champsSignataireEnum.recherche]: '',
	[champsSignataireEnum.id]: '',
	[champsSignataireEnum.nom]: '',
	[champsSignataireEnum.prenom]: '',
	[champsSignataireEnum.telephone]: '',
	[champsSignataireEnum.courriel]: '',
	[champsSignataireEnum.type]: typeSignataire.Signataire,
	[champsSignataireEnum.methodeAuth]: methodeAuthentification.SMS,
	[champsSignataireEnum.positionSignature]: Object.keys(positionSignature)[Object.values(positionSignature).indexOf(positionSignature.hautGauche)] as positionSignature,
	[champsSignataireEnum.enregistrerDestinataire]: false
}

export const INITIAL_VALEURS_FORMULAIRE_SUIVEUR = {
	[champsSuiveurEnum.recherche]: '',
	[champsSuiveurEnum.nom]: '',
	[champsSuiveurEnum.prenom]: '',
	[champsSuiveurEnum.courriel]: ''
}
